<template>
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">인터페이스 그룹 목록</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" @click="openSettingPopup('ADD')"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="deleteBtnDisabled" @click="deleteInterfaceGroup"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper row-class-name="c-dblclick" :data="interfaceGroupList" :columns="tableColumns" :column-default="columnDefault" remote pagination :total="total" :show-search-tool="showSearchTool" :show-custom-header="true"
        @row-dblclick="onRowDblClick" @selection-change="onSelectionChange" @condition-change="loadData" ref="interfaceGroupTable">
        <template slot-scope="scope" slot="nicount-slot">
          <span class="link" @click="openInterfaceListPopup(scope.row)">{{ scope.row.netinterfaceCount }}</span>
        </template>
    </el-table-wrapper>

    <!-- 인터페이스 그룹 추가/수정 팝업 -->
    <w-interface-group-setting-sliding-popup :popup-params="settingPopupParams" @reload="loadData" ref="settingPopup"></w-interface-group-setting-sliding-popup>

    <!-- 인터페이스 목록 조회 팝업 -->
    <w-interface-list-sliding-popup :popup-params="listPopupParams" ref="listPopup"></w-interface-list-sliding-popup>
  </div>
</w-settings-content-template>
</template>

<script>
import msgUtil from '@/utils/message';
import trafficAPI from '@/api/settings/netdevice/traffic-settings';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WInterfaceGroupSettingSlidingPopup from './popup/InterfaceGroupSettingSlidingPopup';
import WInterfaceListSlidingPopup from './popup/InterfaceListSlidingPopup';

export default {
  name: 'WInterfaceGroupSettings',
  components: {
    WSettingsContentTemplate,
    WInterfaceGroupSettingSlidingPopup,
    WInterfaceListSlidingPopup,
  },
  data() {
    return {
      showSearchTool: false,
      deleteBtnDisabled: true,
      columnDefault,
      total: null,
      interfaceGroupList: [],
      tableColumns: [
        {
          type: 'selection',
        },
        {
          prop: 'interfaceGroupName',
          label: '인터페이스 그룹명',
          remoteProp: 'interface_group_name',
          width: 200,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'interfaceGroupDesc',
          label: '설명',
          remoteProp: 'interface_group_desc',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceCount',
          label: '인터페이스 개수',
          scopedSlot: 'nicount-slot',
          width: 150,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'orderbyIndex',
          label: '정렬순서',
          width: 150,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      settingPopupParams: {},
      listPopupParams: {},
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 인터페이스 그룹 목록 조회
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      const tableParams = this.$refs.interfaceGroupTable.getParameter();

      trafficAPI.getInterfaceGroupList(tableParams).then((response) => {
        if (response.data.success) {
          this.interfaceGroupList = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    /**
     * 인터페이스 그룹 설정 팝업 open
     * @author jeee12
     * @param  {[type]} popupType [description]
     * @return {[type]}           [description]
     */
    openSettingPopup(popupType, selectedRecord) {
      this.settingPopupParams.popupType = popupType;
      if (popupType === 'ADD') {
        this.settingPopupParams.interfaceGroupList = this.interfaceGroupList;
      } else if (popupType === 'UPDATE') {
        this.settingPopupParams.selectedRecord = selectedRecord;
      }
      this.$refs.settingPopup.open();
    },
    /**
     * 인터페이스 그룹의 인터페이스 목록 팝업 open
     * @author jeee12
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    openInterfaceListPopup(row) {
      this.listPopupParams = row;
      this.$refs.listPopup.open();
    },
    onSelectionChange(selection) {
      if (selection.length > 0) this.deleteBtnDisabled = false;
      else this.deleteBtnDisabled = true;
    },
    /**
     * row 더블 클릭, 인터페이스 그룹 수정 팝업 open
     * @author jeee12
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowDblClick(row) {
      this.openSettingPopup('UPDATE', row);
    },
    /**
     * 선택한 인터페이스 그룹 삭제
     * @author jeee12
     * @return {[type]} [description]
     */
    deleteInterfaceGroup() {
      const selection = this.$refs.interfaceGroupTable.$children[0].selection;
      if (selection.length === 0) {
        this.$message(msgUtil.getCustomMsgData('대상을 선택해주세요.'));
        return;
      }

      this.$confirm('삭제하시겠습니까?', '확인', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }).then(() => {
        trafficAPI.deleteInterfaceGroup(selection).then((response) => {
          if (response.data.success) {
            this.$alert('인터페이스 그룹을 삭제하였습니다.', '정보', {
              callback: () => {
                this.loadData();
              },
            });
          }
        });
      }).catch(() => {});
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/InterfaceGroupSettings/index.vue